<template>
  <div>
    <el-rate :max='3' />
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="postcss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/cx/cxRate.vue